import { createSelector } from 'reselect';

export const FamilyAccountSelector = (state) => state.family_account;

export const getFamilyAccounts = createSelector(
    [FamilyAccountSelector],
    (state) => state.familyAccounts
);
